import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import React from "react";
import Styles from "./spinner-styles";
import SpinnerSVG from "../../assets/images/spinner.svg";

const Spinner = (props) => {
  const classes = Styles();
  
  return (
    <Dialog
      open={props.open}
      PaperProps={{
        className: classes.root
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogContent>
        <Box width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
          <img src={SpinnerSVG} className={classes.animatedItem} alt="" />
          <Typography variant="subtitle1" className={classes.text}>
            {props.message || 'Aguarde...'}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default Spinner;
